import createDestination from './create-destination.json';
import destination from './destination.json';
import destinations from './destinations.json';

export default {
  destinations,
  destination,
  createDestination,
};
